import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_ENDPOINT;
const token = process.env.REACT_APP_DEALER_TOKEN;

export const fetchCustomerActivity = createAsyncThunk(
    'v1/customer-activities/latest',
    async (_, { rejectWithValue }) => {
        try {
            console.log(token);
            const response = await axios.get(`${API_URL}/v1/customer-activities/latest`, {
                headers: {
                    token: token,
                }
            });

            return response.data.data;
        } catch (error) {
            console.error(`Error fetching data:`, error);
            return rejectWithValue(error.response?.data || 'Failed to fetch items');
        }
    }
)

export const createVehicle = createAsyncThunk(
    'v1/customer-activities/vehicles',
    async (item, { getState, rejectWithValue }) => {
        try {
            const response = await axios.post(`${API_URL}/v1/customer-activities/vehicles`, item, {
                headers: {
                    token: token,
                },
            });

            return response.data;
        } catch (error) {
            console.error(`Error store vehicles:`, error.message);
            return rejectWithValue(error.response?.data || "Failed to create item");
        }
    }
);

export const changeOwnership = createAsyncThunk(
    'v1/customer-activities/ownership',
    async (item, { getState, rejectWithValue }) => {
        try {
            const response = await axios.post(`${API_URL}/v1/customer-activities/ownership`, item, {
                headers: {
                    token: token,
                },
            });

            return response.data;
        } catch (error) {
            console.error(`Error change ownership:`, error.message);
            return rejectWithValue(error.response?.data || "Failed to change ownership");
        }
    }
);

export const fetchCustomerById = createAsyncThunk(
    "v1/customer-activities/customer",
    async ({ oneAccountId, dealerCustomerId }, { rejectWithValue }) => {
        try {
            const params = {};
            if (oneAccountId) params.one_account_id = oneAccountId;
            if (dealerCustomerId) params.dealer_customer_id = dealerCustomerId;

            const response = await axios.get(`${API_URL}/v1/customer-activities/customer`, { params }, {
                headers: {
                    token: token,
                },
            });
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Failed fetch data");
        }
    }
);

const customerActivitySlice = createSlice({
    name: 'customerActivity',
    initialState: {
        customer: [],
        vehicles: [],
        ownership: [],
        isLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCustomerActivity.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchCustomerActivity.fulfilled, (state, action) => {
                state.isLoading = false;
                state.customer = action.payload;
            })
            .addCase(fetchCustomerActivity.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })
            .addCase(createVehicle.fulfilled, (state, action) => {
                state.isLoading = false;
                state.vehicles.push(action.payload.data);
            })
            .addCase(changeOwnership.fulfilled, (state, action) => {
                state.isLoading = false;
                state.ownership.push(action.payload.data);
            })
            // Handle fetchCustomerById
            .addCase(fetchCustomerById.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchCustomerById.fulfilled, (state, action) => {
                state.isLoading = false;
                state.customer = action.payload;
            })
            .addCase(fetchCustomerById.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });
    },
});

export default customerActivitySlice.reducer;